module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAcCAYAAAAEN20fAAAACXBIWXMAABYlAAAWJQFJUiTwAAAA8UlEQVRIid2X0Q2CMBCGPxvfZQQ2cARxE0fQCcQN2MAZ3KBugJuwwe9DhRjCg6VNevFLLiGXcvmg10KRhKRKktfvDJKaz71ZYrw4R0h8c8ol4ghUrOMOaGX0QDMWcpRjD3QWRCDIAOVFJhxwAq4FHXqg2kgagF1BEYCLMyABUJnqERPkELkBTwsiLeBTi/zV1OTAO+BV2gLCGxkixh+BzSwg9Mk8H9XA25jBhM9BM8u1n9w8X0dVVtyf2RJIahNrNFaa1cyq6a2IDFvCrnhIKOKJbcwFYlfNEikPMWFlamyJ+MIOD2A66XWJG9Jaekm1JN64/BLAJMA3QQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/connect_ecosoft_com/images/icon_folder_plus@2x.png
// module id = 1777
// module chunks = 0